<template>
  <transition name="modal">
    <div class="modal__mask bg-black bg-opacity-50" v-if="showModalCreate">
      <div class="modal__wrapper">
        <div class="modal__container reset bg-white dark:bg-slate-800">
          <div class="content__modal">
            <div class="inner__modal">
              <div class="flex items-center gap-3 mb-6">
                <img
                  class="w-12 h-12"
                  src="@/assets/addRepresentante.png"
                  alt="Adicionar"
                />
                <h2 class="text-lg font-semibold">
                  Adicionar representante FATCA
                </h2>
              </div>

              <form
                action=""
                class="form__class"
                @submit.stop.prevent="createRepresentante"
              >
                <div class="space-y-4">
                  <div class="form-field">
                    <InputNome
                      v-model="representante.Nome"
                      label="Nome/Denominação Social"
                      :required="true"
                      :erroDesc="erroName"
                    />
                  </div>

                  <div class="form-field">
                    <label class="form-field-label form-field-label-required">
                      % Participação Societária
                    </label>
                    <input
                      class="field"
                      @click.stop.prevent="clear"
                      v-model="representante.Percentual"
                      type="text"
                      v-money="opcoesDeMoeda"
                      placeholder="0,00 %"
                    />
                  </div>

                  <div class="form-field">
                    <label class="form-field-label">
                      Documento de identidade
                    </label>
                    <input
                      type="text"
                      class="field"
                      autocomplete="off"
                      @click.stop.prevent="clear"
                      v-model="representante.Documento"
                    />
                  </div>

                  <div class="form-field">
                    <label class="form-field-label"> CPF/CNPJ </label>
                    <input
                      type="text"
                      class="field"
                      autocomplete="off"
                      @click.stop.prevent="clear"
                      v-model="representante.CpfCnpj"
                    />
                  </div>
                </div>

                <div class="flex gap-3 mt-6">
                  <button
                    class="btn-secondary"
                    type="button"
                    @click="closeModal"
                  >
                    Cancelar
                  </button>
                  <button
                    v-if="representante.Guid == ''"
                    class="btn-primary"
                    type="button"
                    @click="salvarRepresentante"
                  >
                    Adicionar
                  </button>
                  <button
                    v-if="representante.Guid != ''"
                    class="btn-primary"
                    type="button"
                    @click="salvarRepresentante"
                  >
                    Atualizar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/axios";
import { VMoney } from "v-money";

export default {
  directives: {
    money: VMoney,
  },
  computed: {
    ...mapGetters({
      showModalCreate: "GET_MODAL_PJ_ADD_PESSOA_FATCA",
      editarRepresentante: "GET_MODAL_PJ_EDITAR_PESSOA",
      user: "auth/user",
    }),
  },
  data() {
    return {
      disableBtn: false,
      erroName: "",
      representante: {
        Guid: "",
        Nome: "",
        CpfCnpj: "",
        Documento: "",
        Percentual: 0,
      },
      opcoesDeMoeda: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
      },
    };
  },
  watch: {
    editarRepresentante() {
      this.representante = this.editarRepresentante;
      debugger; // eslint-disable-line no-debugger
      if (this.representante)
        this.representante.Percentual = this.representante.Percentual * 100;
    },
  },
  methods: {
    formatarValorFinanceiro(valorString) {
      if (valorString == null || valorString == "") return 0;

      const valorNumerico = parseFloat(
        valorString.replace("R$ ", "").replace(/\./g, "").replace(",", "."),
      );
      return isNaN(valorNumerico) ? 0 : valorNumerico; // Retorna 0 se não for um número
    },
    closeModal() {
      this.$store.commit("SET_MODAL_PJ_ADD_PESSOA_FATCA", false);
      this.$store.commit("SET_MODAL_PJ_EDITAR_PESSOA", null);
    },
    limparObj() {
      this.representante = {
        Guid: "", // valor padrão
        Nome: "", // valor padrão
        Documento: "",
        CpfCnpj: "", // valor padrão
        Percentual: 0,
      };
    },
    async salvarRepresentante() {
      this.disableBtn = true;

      var saveRepresentanteObj = JSON.parse(JSON.stringify(this.representante));

      saveRepresentanteObj.Percentual = this.formatarValorFinanceiro(
        this.representante.Percentual,
      );

      await api
        .post("/fundo/facta", saveRepresentanteObj)
        .then((retorno) => {
          this.disableBtn = false;
          if (retorno.status == 200) {
            this.$swal({
              icon: "success",
              title:
                this.representante.Guid == ""
                  ? "Inclusão realizada com sucesso!"
                  : "Alteração realizada com sucesso!",
              text: "Dados informados foram salvos com sucesso.",
            });
            this.limparObj();
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA_FATCA", false);

            this.$store.dispatch("FETCH_FI_LISTA_REPRESENTANTES");
          }
        })
        .catch((error) => {
          this.disableBtn = false;
          this.$swal({
            icon: "error",
            title: "Dados informados inválidos informado para representante",
            text: `${error.response.data.data[0]}`,
          });
        });
    },
  },
};
</script>
